import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { mutate } from "lib/graphql/mutate"

export const getColumnState = api(async function columnState({ key }) {
    return query(
        gql`
            query ColumnState($key: String!) {
                columnState(key: $key)
            }
        `,
        { key },
        { returns: "columnState" }
    )
})

export const saveColumnState = api(async function saveColumnState({ key, state }) {
    return mutate(
        gql`
            mutation SaveColumnState($key: String!, $state: JSON!) {
                saveColumnState(key: $key, state: $state)
            }
        `,
        { key, state },
        { returns: "saveColumnState" }
    )
})
